type PossibleClass = string | boolean | undefined;

export const classNames = (...classes: PossibleClass[]) => {
  return classes.filter(Boolean).join(' ');
};
